// Auto-generated file - do not edit manually
// Run 'node scripts/generate-asset-manifest.js' to regenerate
// This file is generated from public/assets/ directory

export const BANNERS = [
  'assets/banners/banner-1.jpg',
  'assets/banners/banner-2.jpg',
  'assets/banners/banner-3.gif',
  'assets/banners/banner-4.gif',
  'assets/banners/banner-5.png',
] as const;

export const NOT_FOUND_IMAGES = ['assets/not-found/not-found-1.png'] as const;
